import { useSelector } from "react-redux";
import { getSelectedMover } from "@/store/mover/slice";
import LineItems from "../EditMove/LineItems";

export default function Billing() {
  const selectedMover = useSelector(getSelectedMover);

  if (!selectedMover) {
    return null;
  }

  return (
    <div className="relative">
      <LineItems mode="edit" buttonsPosition="top" />
    </div>
  );
}
